import { StyledIcon, StyledIconBase } from "@styled-icons/styled-icon";
import { Button, Col } from "components/primitives";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

interface ButtonChoice {
  name: string;
  value: any;
  icon: StyledIcon;
}

interface ChooseBetweenButtonsInfo {
  label: string;
  choices: Array<ButtonChoice>;
}

export const ChooseBetweenButtonsSetting: WidgetSettingFC<any, ChooseBetweenButtonsInfo> = ({
  data,
  setData,
  info: { label, choices },
}) => {
  return (
    <OuterContainer>
      <HeaderText>{label}</HeaderText>
      <ButtonContainer>
        {choices.map((choice, i) => {
          const Icon = choice.icon;
          return (
            <SettingButton
              key={i}
              onClick={() => setData(choice.value)}
              highlighted={choice.value === data}
            >
              {Icon && <Icon />}
              <p>{choice.name}</p>
            </SettingButton>
          );
        })}
      </ButtonContainer>
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)`
  padding: 3px;
  margin-bottom: 35px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 1em;
  flex-direction: row;
  flex-wrap: wrap;
`;

const SettingButton = styled(Button)`
  width: 47%;
  display: flex;
  flex-direction: column;
  aspect-ratio: 0.85;

  ${StyledIconBase} {
    width: 80%;
  }
`;

const HeaderText = styled.p`
  color: var(--secondary);
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 12pt;
`;
